import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Avatar,
  IconButton,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../../../components/ProgressCom";
import Detail from "../../../../main/detail/Detail";
import { useRecoilState } from "recoil";
import {
  rsGotoLast,
  rsProgress,
  rsActiveMenu,
  rsParentCom,
} from "../../../../RecoilStates";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import useBreakpoints from "../../../../hooks/useBreakpoints";
import { UseLandingHero } from "./UseLandingHero";
import CloseIcon from "@mui/icons-material/Close";

export default function AddLandingHero() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState();
  const { addLandingHero, validate } = UseLandingHero();
  const [imgState, setImgState] = useState({
    file1: undefined,
    url1: undefined,
    file2: undefined,
    url2: undefined,
    file3: undefined,
    url3: undefined,
  });
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    aid: location.state.SlideID,
    title: undefined,
    description: undefined,
    url: undefined,
    isFix: false,
    isSide: false,
    writer: undefined,
    startDate: undefined,
    endDate: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    url: false,
    file1: false,
    file2: false,
  });

  const handleChangeImage1 = (e) => {
    setImgState({
      ...imgState,
      file1: e.target.files[0],
      url1: URL.createObjectURL(e.target.files[0]),
    });
  };

  const handleChangeImage2 = (e) => {
    setImgState({
      ...imgState,
      file2: e.target.files[0],
      url2: URL.createObjectURL(e.target.files[0]),
    });
  };

  const handleRemoveImage3 = () => {
    setImgState((prev) => ({
      ...prev,
      file3: undefined,
      url3: undefined,
    }));
  };

  const handleChangeImage3 = (e) => {
    setImgState({
      ...imgState,
      file3: e.target.files[0],
      url3: URL.createObjectURL(e.target.files[0]),
    });
  };

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, startDate: newValueStart });
  }, [valueStart]);

  useEffect(() => {
    let newValueEnd = valueEnd?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, endDate: newValueEnd });
  }, [valueEnd]);

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/SlidesManage",
            SlideID: location.state.SlideID,
            componentFaTitle: location.state.componentFaTitle,
          },
          { name: "هدر جدید", url: "/SlidesManage/addLandingHero" },
        ],
      }}
    >
      {!user ? (
        <Box display="grid" gap={3}>
          <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <TextField
                fullWidth
                value={state.title ? state.title : ""}
                error={errorState.title}
                label="عنوان"
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, title: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 9"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                value={state.url ? state.url : ""}
                error={errorState.url}
                label="آدرس"
                sx={{
                  textarea: {
                    direction: "rtl",
                  },
                }}
                multiline
                rows={2}
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, url: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                value={state.description ? state.description : ""}
                label="توضیحات"
                multiline
                rows={2}
                size="small"
                variant="outlined"
                onChange={(evt) => {
                  setState({ ...state, description: evt.target.value });
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}

            <Box
              gridColumn={isSmall ? "span 12" : "span 7"}
              flexDirection="column"
            >
              <Typography>تصویر هدر</Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isSmall ? "column" : "row",
                  alignItems: isSmall ? "flex-start" : "center",
                  gap: 5,
                }}
              >
                <Box component="label">
                  <Avatar
                    sx={{
                      border: "1px solid #d9d9d9",
                      borderRadius: 3,
                      width: "100%",
                      height: "150px",
                      p: 1,
                    }}
                    src={
                      imgState.url1 ? imgState.url1 : "/static/img/nobanner.jpg"
                    }
                    alt="img"
                  />
                  <input
                    type="file"
                    id="img"
                    name="avatarName"
                    accept="image/*"
                    multiple
                    onChange={handleChangeImage1}
                    hidden
                  />
                </Box>
                <Box component="label">
                  <Avatar
                    sx={{
                      border: "1px solid #d9d9d9",
                      borderRadius: 3,
                      width: "100%",
                      height: "150px",
                      p: 1,
                    }}
                    src={
                      imgState.url2 ? imgState.url2 : "/static/img/nobanner.png"
                    }
                    alt="img"
                  />
                  <input
                    type="file"
                    id="img"
                    name="avatarName"
                    accept="image/*"
                    multiple
                    onChange={handleChangeImage2}
                    hidden
                  />
                </Box>
              </Box>
            </Box>
            {!isSmall && <Box gridColumn="span 5"></Box>}
            <Box
              gridColumn={isSmall ? "span 12" : "span 6"}
              display="flex"
              flexDirection="column"
              gap={1}
            >
              <Typography>تصویر نویسنده</Typography>

              <Box sx={{ position: "relative", width: 120, height: 120 }}>
                <Box
                  component="label"
                  sx={{
                    display: "block",
                    width: 120,
                    height: 120,
                    cursor: "pointer",
                  }}
                >
                  <Avatar
                    variant="rounded"
                    sx={{
                      border: "1px solid #d9d9d9",
                      borderRadius: 3,
                      width: 120,
                      height: 120,
                      p: 1,
                    }}
                    src={imgState.url3 || "/static/img/nobanner.jpg"}
                    alt="تصویر نویسنده"
                  />

                  <input
                    type="file"
                    id="writerImage"
                    name="writerImage"
                    accept="image/*"
                    onChange={handleChangeImage3}
                    hidden
                  />
                </Box>

                {imgState.url3 && (
                  <IconButton
                    size="small"
                    aria-label="حذف تصویر نویسنده"
                    onClick={handleRemoveImage3}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      zIndex: 1,
                      bgcolor: "error.main",
                      color: "white",
                      width: 28,
                      height: 28,
                      "&:hover": {
                        bgcolor: "error.dark",
                      },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            </Box>

            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="متن نویسنده"
                value={state.writer?.text ?? ""}
                onChange={(e) =>
                  setState({
                    ...state,
                    writer: {
                      ...state.writer,
                      text: e.target.value,
                    },
                  })
                }
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="نام نویسنده"
                value={state.writer?.name ?? ""}
                onChange={(e) =>
                  setState({
                    ...state,
                    writer: {
                      ...state.writer,
                      name: e.target.value,
                    },
                  })
                }
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 6"}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="آدرس نویسنده"
                value={state.writer?.url ?? ""}
                onChange={(e) =>
                  setState({
                    ...state,
                    writer: {
                      ...state.writer,
                      url: e.target.value,
                    },
                  })
                }
              />
            </Box>
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box
              sx={{ display: "flex", gap: 2 }}
              gridColumn={isSmall ? "span 12" : "span 7"}
            >
              <DatePicker
                weekDays={weekDays}
                calendar={persian}
                locale={persian_fa}
                format="YYYY-MM-DD"
                value={valueStart}
                onChange={setValueStart}
                render={
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    size="small"
                    fullWidth
                    label="تاریخ شروع"
                  />
                }
              />
              <DatePicker
                weekDays={weekDays}
                calendar={persian}
                locale={persian_fa}
                format="YYYY-MM-DD"
                value={valueEnd}
                onChange={setValueEnd}
                render={
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    label="تاریخ پایان"
                    size="small"
                    fullWidth
                  />
                }
              />
            </Box>
            {!isSmall && <Box gridColumn="span 5"></Box>}
            <Box gridColumn={isSmall ? "span 12" : "span 3"}>
              <FormControlLabel
                checked={state.isFix}
                onChange={(evt) => {
                  setState({ ...state, isFix: evt.target.checked });
                }}
                control={<Checkbox />}
                label=" جایگاه نمایش ثابت شود "
              />
            </Box>
            {(location.state?.ComponentID == 14 ||
              location.state?.ComponentID == 45) && (
              <Box gridColumn={isSmall ? "span 12" : "span 3"}>
                <FormControlLabel
                  checked={state.isSide}
                  onChange={(evt) => {
                    setState({ ...state, isSide: evt.target.checked });
                  }}
                  control={<Checkbox />}
                  label="هدر کناری"
                />
              </Box>
            )}
            {!isSmall && <Box gridColumn="span 6"></Box>}
            <Box
              gridColumn={isSmall ? "span 12" : "span 6"}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                sx={{ mr: 2, width: "70px" }}
                variant="contained"
                onClick={() => {
                  if (validate(state, imgState, setErrorState, true) == 200) {
                    var landingModel = {
                      aid: state.aid,
                      title: state.title,
                      url: state.url,
                      description: state.description,
                      writer: {
                        text: state.writer.text,
                        name: state.writer.name,
                        url: state.writer.url,
                      },
                      isFix: state.isFix,
                      isSide: state.isSide,
                      isActive: state.isActive,
                      startDate: state.startDate,
                      endDate: state.endDate,
                    };

                    setProgress(true);
                    addLandingHero(
                      landingModel,
                      imgState.file1,
                      imgState.file2,
                      imgState.file3,
                      () => {
                        setMsGotoLast(true);
                        navigate(
                          "/landingmanagment/landingComponents/landinghero",
                          {
                            state: { ...location.state, isBack: true },
                            replace: true,
                          },
                        );
                      },
                    );
                  }
                }}
              >
                ثبت
              </Button>
              <Button
                sx={{ width: "70px" }}
                variant="outlined"
                onClick={() => {
                  navigate("/SlidesManage", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }}
              >
                بازگشت
              </Button>
            </Box>
            {!isSmall && <Box gridColumn="span 9"></Box>}
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
